import { render, staticRenderFns } from "./AccordianSection.vue?vue&type=template&id=4b6844b4&scoped=true"
import script from "./AccordianSection.vue?vue&type=script&lang=js"
export * from "./AccordianSection.vue?vue&type=script&lang=js"
import style0 from "./AccordianSection.vue?vue&type=style&index=0&id=4b6844b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6844b4",
  null
  
)

export default component.exports